<template>
    <div class="lottery-chance-container">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="chance-container">
            <van-empty v-if="ChanceList.length <= 0" description="没有抽奖机会" />
            <van-list v-else :finished="finished" :error.sync="error" finished-text="没有更多了" @load="onLoad">
                <van-cell class="lottery-chance-item lottery-chance-main" v-for="(item, index) in ChanceList" :key="index" is-link
					:title="item.activity.name"
					@click="$router.push({ name : 'SpinLottery', query : { id : item.activity_id } })"
					>
					<template slot="label">获得时间：{{item.created_at}}</template>
                </van-cell>
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
    import api from "../../assets/js/api";

    export default {
        name: 'LotteryChance',
        data () {
            return {
                loading: false,
                finished: false,
                refreshing: false,
                error : false,
                params : {
                    page : 1,
                    page_size : 20,
                },
                ChanceList : [],
            };
        },
        created() {
            this.onRefresh();
        },
        methods : {
            onLoad(){
                let self = this;
                if(self.loading) return;

                self.loading = true;
                api.request('/user_lottery/list', Object.assign({}, self.params)).then(res => {
                    if(self.params.page >= res.data.max_page){
                        self.finished = true;
                    }else{
                        self.params.page++;
                    }

                    // 如果是刷新就把数据清空
                    if(self.refreshing){
                        self.ChanceList = [];
                    }

                    for(let index in res.data.data){
                        self.ChanceList.push(res.data.data[index]);
                    }
                }).catch(res => {
                    self.error = true;
                }).finally(() => {
                    self.loading = false;
                    self.refreshing = false;
                });
            },
            onRefresh() {
                this.finished = false;
                this.refreshing = true;
                this.params.page = 1;
                this.onLoad();
            },
        },
    }
</script>

<style lang="scss">
    .lottery-chance-container {
        padding: 10px;

		.chance-container {
			min-height: 100vh;

			.lottery-chance-item{
				border: 1px solid #eeeeee;
				border-radius: 10px;
				margin-bottom: 10px;
				height: 2rem;

				.lottery-chance-main {
					padding: 10px;
					font-size: 0.5rem;
					.lottery-chance-title {
						height: 100%;
						display: flex;
						justify-content: center;
						align-items: center;
					}
				}
			}
		}
    }

</style>



// WEBPACK FOOTER //
// src/pages/user/LotteryChance.vue